import { useEffect } from 'react'
import { useCookies } from 'react-cookie'

export default function useToken() {
  const [cookies] = useCookies(['auth_token', 'user_name'])
  const cookieToken = cookies.auth_token
  const sessionToken =
    typeof window !== 'undefined' ? sessionStorage.getItem('auth_token') : null

  // When cookie is accessible, keep sessionStorage in sync so it's available
  // on subsequent navigations where the cookie may be blocked (e.g. iframe context)
  useEffect(() => {
    if (cookieToken && cookieToken !== sessionToken) {
      sessionStorage.setItem('auth_token', cookieToken)
    }
  }, [cookieToken])

  return cookieToken || sessionToken || false
}
